import styled, { keyframes } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const LOADER_WIDTH = "40px";

const hideElement = keyframes`
    to {
      opacity: 0;
      visibility: hidden;
    }
`;

export const StyledAutoHiddenElement = styled.div`
    animation: ${hideElement} ease-in-out 1s forwards;
    animation-delay: 1s;
`;

export const StyledSuccessIcon = styled(SWReactIcons)`
    & svg g {
        fill: ${colorsPalettes.blue["400"]};
    }
`;

export const StyledDotsLoaderContainer = styled.div`
    padding-left: ${LOADER_WIDTH};
`;

export const StyledFlexContainer = styled(FlexRow)`
    align-items: center;
`;
